/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// external-global styles must be imported in your JS.
import normalizeCss from 'normalize.css';
import s from './Layout.css';
import NotificationPopUpManager from '../Popup/NotificationPopUpManager';
import HistoryEvents from '../HistoryEvents';
import HistoryParameters from '../HistoryParameters';
import ConversationPopup from '../ConversationPopup';
import BasicHeader from '../BasicHeader';
import Footer from '../Footer';

class Layout extends React.Component {

  render() {
    const { loggedOut } = this.props;
    if (loggedOut) {
      return (
        <div className={s.box}>
          {this.props.children}
          <NotificationPopUpManager lang={'en'} />
          <Footer />
        </div>
      );
    }
    return (
      <div>
        <BasicHeader pathname={this.props.pathname} />
        {this.props.children}
        <NotificationPopUpManager lang={'en'} />
        <HistoryEvents />
        <HistoryParameters />
        <ConversationPopup />
        <Footer />
      </div>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  loggedOut: PropTypes.bool,
  pathname: PropTypes.string,
};

Layout.defaultProps = {
  loggedOut: false,
  pathname: '',
};

export default withStyles(normalizeCss, s)(Layout);



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js